import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";
import { MdEdit, MdLockReset } from "react-icons/md";
import "./Profile.css";
import ProfileServices from "../../services/ProfileServices";
import Loader from "../../components/Loader";
import EditProfileModal from "./modals/EditProfileModal";
import ChangePasswordModal from "./modals/ChangePasswordModal";

const Profile = () => {
  const { user, updateProfile } = useContext(AuthContext);
  const profileApi = new ProfileServices();

  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(user);
  const [editOpen, setEditOpen] = useState(false);
  const [changePassOpen, setChangePassOpen] = useState(false);

  const loadProfile = async () => {
    setLoading(true);
    try {
      const res = await profileApi.getMyProfile();
      if (res.isSuccess) {
        setProfile(res.data);
        // keep auth context in sync for TopBar/Sidebar name
        updateProfile({
          ...(user || {}),
          ...res.data,
        });
      } else {
        toast.error(res.message || "Failed to load profile");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleProfileUpdated = (updated) => {
    setProfile(updated);
    updateProfile({
      ...(user || {}),
      ...updated,
    });
  };

  return (
    <div className="profile-page">
      <div className="profile-card">
        <div className="profile-header">
          <div>
            <h2 className="profile-title">My Profile</h2>
            <p className="profile-subtitle">Manage your personal details and security</p>
          </div>

          <div className="profile-actions">
            <button className="profile-btn primary" onClick={() => setEditOpen(true)}>
              <MdEdit />
              Edit Profile
            </button>
            <button className="profile-btn light" onClick={() => setChangePassOpen(true)}>
              <MdLockReset />
              Change Password
            </button>
          </div>
        </div>

        <div className="profile-body">
          {loading ? (
            <Loader message="Loading profile..." />
          ) : (
            <div className="profile-grid">
              <div className="profile-item">
                <div className="profile-label">Name</div>
                <div className="profile-value">{profile?.name || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">User Name</div>
                <div className="profile-value">{profile?.username || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Mobile</div>
                <div className="profile-value">{profile?.mobile || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Reference ID</div>
                <div className="profile-value">{profile?.game_id || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Nike Name</div>
                <div className="profile-value">{profile?.nike_name || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Location</div>
                <div className="profile-value">{profile?.location || "-"}</div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Role</div>
                <div className="profile-value">
                  <span className="profile-badge">{profile?.role ?? "-"}</span>
                </div>
              </div>
              <div className="profile-item">
                <div className="profile-label">Status</div>
                <div className="profile-value">
                  <span className="profile-badge">
                    {profile?.is_active === 1 ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <EditProfileModal
        show={editOpen}
        onClose={() => setEditOpen(false)}
        profile={profile}
        onUpdated={handleProfileUpdated}
      />

      <ChangePasswordModal
        show={changePassOpen}
        onClose={() => setChangePassOpen(false)}
      />
    </div>
  );
};

export default Profile;